import { useState } from "react";
import "../../../styles/support.css";

import VerifiedNavigation from "../../navigation/components/VerifiedNavigation";
import { AuthServices } from "../../auth/services/AuthServices";

const Support = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name) newErrors.name = "Name is required";
    if (!formData.email) newErrors.email = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.email))
      newErrors.email = "Email address is invalid";
    if (!formData.message) newErrors.message = "Message is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    const response = await AuthServices.emailSupport(formData);
    if (!response.success) {
      setErrors({
        form: "There was an error sending your message. Please try again later.",
      });
      return;
    }
    setSuccessMessage(
      "Your message has been sent successfully. We will contact you shortly."
    );
    setFormData({ name: "", email: "", message: "" });
    setErrors({});
  };

  return (
    <div className="support">
      <VerifiedNavigation />
      <div className="support-container">
        <div className="support-page">
          <div className="support-header">
            <p style={{ color: "orange", paddingBottom: "10px" }}>Support</p>
            <h1 style={{ fontSize: "3rem" }}> Need Help?</h1>
            <p>Send us a message and well get right back to you.</p>
          </div>

          <div className="support-form-container">
            {successMessage && (
              <p className="success-message">{successMessage}</p>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input
                  placeholder="Full Name"
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && <p className="error-message">{errors.name}</p>}
              </div>

              <div className="form-group">
                <label htmlFor="email">Email *</label>
                <input
                  placeholder="you@company.com"
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
                {errors.email && (
                  <p className="error-message">{errors.email}</p>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="message">Message </label>
                <textarea
                  rows={10}
                  placeholder="Leave us a message."
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                />
                {errors.message && (
                  <p className="error-message">{errors.message}</p>
                )}
              </div>
              <div className="privacy-policy">
                <input required type="checkbox" name="checkbox" id="checkbox" />
                <label htmlFor="checkbox">
                  You agree to our <span>privacy policy</span>
                </label>
              </div>
              <button type="submit" className="submit-btn">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;
